import axios from "axios";
import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import swal from "sweetalert";
import CAPTCHATurnStile from "../admin/childComponents/appComponents/CAPTCHATurnStile";
import InputField from "../admin/childComponents/inputComponents/InputFieldLogin";
import { useLocation } from "react-router-dom";

const Forgotpassword02b = (props) => {
  const location = useLocation();
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const BUTTON_NAME = "Reset Password";
  const { otp } = useParams();
  const navigate = useNavigate("");

  const [reCaptcha, setReCaptcha] = useState(false);

  //Fetches all Form Data
  const [formData, setFormData] = useState({
    input: {
      otpToken: { otp }.otp,
      email: localStorage.getItem("auth_email"),
      firstName: localStorage.getItem("firstName"),
      lastName: localStorage.getItem("lastName"),
      password: null,
      repeatpassword: null,
      agree: "on",
    },
    select: {},
  });

  // Function to update form data dynamically
  const updateFormData = (type, key, value) => {
    setFormData((prev) => ({
      ...prev,
      [type]: {
        ...prev[type],
        [key]: value,
      },
    }));
  };

  // Reload Page
  const [reloadState, setReloadState] = useState({
    loading: BUTTON_NAME,
  });

  useEffect(() => {
    (async () => await tableLoad(formData.input.otpToken))();
  }, []);

  async function tableLoad(otp) {
    await axios
      .get(BASE_URL + "verifyotp/" + otp)
      .then((res) => {
        if (res.data.status === 200) {
          setFormData((prev) => ({
            ...prev,
            input: {
              email: formData.input.email,
              firstName: formData.input.firstName,
              lastName: formData.input.lastName,
            },
          }));
        }
      });
  }

  async function resetPassword(event) {
    event.preventDefault();
    setReloadState((prev) => ({
      ...prev,
      loading: (
        <div>
          <i className="fa fa-refresh fa-spin"></i>
        </div>
      ),
    }));

    const datas = {
      otpToken: formData.input.otpToken,
      email: formData.input.email,
      password: formData.input.password,
      repeatpassword: formData.input.repeatpassword,
    };
    
    await axios.get("sanctum/csrf-cookie").then((response) => {
      try {
        axios.post(BASE_URL + "forgot_password/create", datas).then((res) => {
          if (res.data.status === 200) {
            swal("Success", res.data.message, "success");
            setReloadState((prev) => ({
              ...prev,
              loading: BUTTON_NAME,
            }));
            navigate("/login");
          } else {
            swal("Warning", res.data.message, "warning");
            setReloadState((prev) => ({
              ...prev,
              loading: BUTTON_NAME,
            }));
          }
        });
      } catch (error) {
        swal("Oops!", "Registration Failed", "error");
        setReloadState((prev) => ({
          ...prev,
          loading: BUTTON_NAME,
        }));
      }
    });
  }
  return (
    <>
      <h2 className="login-title">FORGOT PASSWORD</h2>
      <p class="m-b-20">
        Enter your email new password and we will reset it for you.
      </p>
      <div class="row">
        <div class="col-6">
          <div className="form-group">
            <div className="input-group-icon right">
              <InputField
                label="fa fa-phone"
                name="otpToken"
                size="14"
                placeholder="Paste the OTP"
                required="required"
                value={formData.input.otpToken}
                type="number"
                onChange={updateFormData}
              />
            </div>
          </div>
        </div>
        <div class="col-6">
          <div className="form-group">
            <div className="input-group-icon right">
              <InputField
                label="fa fa-envelope"
                name="email"
                disabled="disabled"
                size="14"
                placeholder="name@example.com"
                required="required"
                value={formData.input.email}
                type="email"
                onChange={updateFormData}
              />
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-6">
          <div className="form-group">
            <div className="input-group-icon right">
              <InputField
                label="fa fa-user"
                name="firstName"
                disabled="disabled"
                size="14"
                placeholder="Your first name"
                required="required"
                value={formData.input.firstName}
                type="text"
                onChange={updateFormData}
              />
            </div>
          </div>
        </div>
        <div class="col-6">
          <div className="form-group">
            <div className="input-group-icon right">
              <InputField
                label="fa fa-user"
                name="lastName"
                disabled="disabled"
                size="14"
                placeholder="Your last name"
                required="required"
                value={formData.input.lastName}
                type="text"
                onChange={updateFormData}
              />
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-6">
          <div className="form-group">
            <div className="input-group-icon right">
              <InputField
                label="fa fa-lock"
                name="password"
                size="14"
                placeholder="Create a password"
                required="required"
                value={formData.input.password}
                type="password"
                onChange={updateFormData}
              />
            </div>
          </div>
        </div>
        <div class="col-6">
          <div className="form-group">
            <div className="input-group-icon right">
              <InputField
                label="fa fa-lock"
                name="repeatpassword"
                size="14"
                placeholder="Confirm password"
                required="required"
                value={formData.input.repeatpassword}
                type="password"
                onChange={updateFormData}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="form-group px-3">
        <InputField
          label="I agree the terms and policy"
          name="agree"
          required=""
          value={formData.input.agree}
          type="checkbox"
          checked={null}
          onChange={updateFormData}
        />
      </div>
      <div className="form-group">
        <CAPTCHATurnStile
                    reCaptcha={reCaptcha}
                    setReCaptcha={setReCaptcha}
                    captcha={location.pathname}
                  />
      </div>
      <div className="form-group">
        <button
          disabled={!reCaptcha}
          className="btn btn-primary col-12"
          onClick={resetPassword}
        >
          {reloadState.loading}
        </button>
      </div>

      <div className="social-auth-hr">
        <span>Follow Us On</span>
      </div>
      <div className="text-center social-auth m-b-20">
        <Link className="btn btn-social-icon btn-twitter m-r-5" to="#">
          <i className="fa fa-twitter"></i>
        </Link>
        <Link className="btn btn-social-icon btn-facebook m-r-5" to="#">
          <i className="fa fa-facebook"></i>
        </Link>
        <Link className="btn btn-social-icon btn-google m-r-5" to="#">
          <i className="fa fa-google-plus"></i>
        </Link>
        <Link className="btn btn-social-icon btn-linkedin m-r-5" to="#">
          <i className="fa fa-linkedin"></i>
        </Link>
      </div>

      <div className="card-footer text-center py-3 d-flex justify-content-between">
        <Link className="small" to="/login">
          Return to login
        </Link>
        <div className="small">
          <Link to="/register01">Need an account? Sign up!</Link>
        </div>
      </div>
    </>
  );
};
export default Forgotpassword02b;
